import { mdiChat, mdiChatOutline } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const MessageIcon = (props: IconProps) => {
    const { filled = false, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__OpenMessage"
            path={filled ? mdiChat : mdiChatOutline}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default MessageIcon
